export const extractImageFileFromInputEvent = (event) =>
  event?.target?.files?.[0] ?? event?.currentTarget?.files?.[0] ?? null;

export const resetFileInputValue = (inputElement) => {
  if (!inputElement) return;
  inputElement.value = "";
};

export const buildImageSelection = (
  file,
  createObjectURL = (nextFile) => URL.createObjectURL(nextFile),
) => {
  if (!file) return null;

  return {
    file,
    previewUrl: createObjectURL(file),
  };
};

export const revokeImageSelection = (
  selection,
  revokeObjectURL = (url) => URL.revokeObjectURL(url),
) => {
  const previewUrl = selection?.previewUrl;
  if (!previewUrl) return;
  revokeObjectURL(previewUrl);
};
